/* DMC Flight Enquiry Widget — build marker: v9-full-126-airport-fallback
   Only change from the previous build: LOCAL_AIRPORTS now includes all
   126 airports (67 India + 29 Middle East + 30 South Asia — Nepal, Sri
   Lanka, Pakistan, Bangladesh, Maldives), matching all-airports-complete.json.
   This is the offline fallback used only when the live /locations API
   is unreachable or returns no results. No other logic, markup, or
   styling changed from v8. */
(function () {
  'use strict';

  const WORKER_URL =
    'https://dmc-travel-lead.deccanmountainclub.workers.dev/';

  const LOCATION_API_URL =
    'https://dmc-travel-lead.deccanmountainclub.workers.dev/locations';

  const BODY_LOCK_CLASS = 'dmc-flight-widget-body-locked';

  const LOCAL_AIRPORTS = [
    { label: 'Bengaluru – Kempegowda International Airport (BLR)', search: 'bengaluru kempegowda international airport blr vobl karnataka india', iata_code: 'BLR' },
    { label: 'Mumbai – Chhatrapati Shivaji Maharaj International Airport (BOM)', search: 'mumbai chhatrapati shivaji maharaj international airport bom vabb maharashtra india', iata_code: 'BOM' },
    { label: 'New Delhi – Indira Gandhi International Airport (DEL)', search: 'new delhi indira gandhi international airport del vidp delhi india', iata_code: 'DEL' },
    { label: 'Bhubaneswar – Biju Patnaik International Airport (BBI)', search: 'bhubaneswar biju patnaik international airport bbi vebs odisha india', iata_code: 'BBI' },
    { label: 'Kolkata – Netaji Subhas Chandra Bose International Airport (CCU)', search: 'kolkata netaji subhas chandra bose international airport ccu vecc west bengal india', iata_code: 'CCU' },
    { label: 'Chennai International Airport (MAA)', search: 'chennai international airport maa vomm tamil nadu india', iata_code: 'MAA' },
    { label: 'Hyderabad – Rajiv Gandhi International Airport (HYD)', search: 'hyderabad rajiv gandhi international airport hyd vohs telangana india', iata_code: 'HYD' },
    { label: 'Amritsar – Sri Guru Ram Das Ji International Airport (ATQ)', search: 'amritsar sri guru ram das ji international airport atq viar punjab india', iata_code: 'ATQ' },
    { label: 'Ahmedabad – Sardar Vallabhbhai Patel International Airport (AMD)', search: 'ahmedabad sardar vallabhbhai patel international airport amd vaah gujarat india', iata_code: 'AMD' },
    { label: 'Jaipur International Airport (JAI)', search: 'jaipur international airport jai vijp rajasthan india', iata_code: 'JAI' },
    { label: 'Varanasi – Lal Bahadur Shastri International Airport (VNS)', search: 'varanasi lal bahadur shastri international airport vns vebn uttar pradesh india', iata_code: 'VNS' },
    { label: 'Lucknow – Chaudhary Charan Singh International Airport (LKO)', search: 'lucknow chaudhary charan singh international airport lko vilk uttar pradesh india', iata_code: 'LKO' },
    { label: 'Dehradun – Jolly Grant Airport (DED)', search: 'dehradun jolly grant airport ded vidn uttarakhand rishikesh haridwar india', iata_code: 'DED' },
    { label: 'Srinagar International Airport (SXR)', search: 'srinagar international airport sxr visr kashmir jammu india', iata_code: 'SXR' },
    { label: 'Leh – Kushok Bakula Rimpochee Airport (IXL)', search: 'leh ladakh kushok bakula rimpochee airport ixl vilh india', iata_code: 'IXL' },
    { label: 'Bagdogra Airport (IXB)', search: 'bagdogra airport ixb vebd west bengal darjeeling gangtok sikkim india', iata_code: 'IXB' },
    { label: 'Guwahati – Lokpriya Gopinath Bordoloi International Airport (GAU)', search: 'guwahati lokpriya gopinath bordoloi international airport gau vegt assam india', iata_code: 'GAU' },
    { label: 'Chandigarh International Airport (IXC)', search: 'chandigarh international airport ixc vicg india', iata_code: 'IXC' },
    { label: 'Goa – Dabolim Airport (GOI)', search: 'goa dabolim airport goi vogo india', iata_code: 'GOI' },
    { label: 'Goa – Manohar International Airport (GOX)', search: 'goa manohar mopa international airport gox voga india', iata_code: 'GOX' },
    { label: 'Kochi – Cochin International Airport (COK)', search: 'kochi cochin international airport cok voci kerala india', iata_code: 'COK' },
    { label: 'Kullu–Manali – Bhuntar Airport (KUU)', search: 'kullu manali bhuntar airport kuu vibr himachal pradesh india', iata_code: 'KUU' },
    { label: 'Dharamshala – Kangra Airport (DHM)', search: 'dharamshala kangra gaggal airport dhm vigg himachal pradesh india', iata_code: 'DHM' },
    { label: 'Kozhikode – Calicut International Airport (CCJ)', search: 'kozhikode calicut international airport ccj vocl kerala india', iata_code: 'CCJ' },
    { label: 'Nagpur – Dr. Babasaheb Ambedkar International Airport (NAG)', search: 'nagpur dr babasaheb ambedkar international airport nag vanp maharashtra india', iata_code: 'NAG' },
    { label: 'Indore – Devi Ahilyabai Holkar International Airport (IDR)', search: 'indore devi ahilyabai holkar international airport idr vaid madhya pradesh india', iata_code: 'IDR' },
    { label: 'Coimbatore International Airport (CJB)', search: 'coimbatore international airport cjb vocb tamil nadu india', iata_code: 'CJB' },
    { label: 'Pune Airport (PNQ)', search: 'pune airport pnq vapo maharashtra india', iata_code: 'PNQ' },
    { label: 'Vadodara Airport (BDQ)', search: 'vadodara airport bdq vabo gujarat india', iata_code: 'BDQ' },
    { label: 'Visakhapatnam Airport (VTZ)', search: 'visakhapatnam vizag airport vtz vovz andhra pradesh india', iata_code: 'VTZ' },
    { label: 'Ranchi – Birsa Munda Airport (IXR)', search: 'ranchi birsa munda airport ixr verc jharkhand india', iata_code: 'IXR' },
    { label: 'Agartala – Maharaja Bir Bikram Airport (IXA)', search: 'agartala maharaja bir bikram airport ixa veat tripura india', iata_code: 'IXA' },
    { label: 'Kannur International Airport (CNN)', search: 'kannur international airport cnn vokn kerala india', iata_code: 'CNN' },
    { label: 'Port Blair – Veer Savarkar International Airport (IXZ)', search: 'port blair veer savarkar international airport ixz vopb andaman nicobar india', iata_code: 'IXZ' },
    { label: 'Madurai Airport (IXM)', search: 'madurai airport ixm vomd tamil nadu india', iata_code: 'IXM' },
    { label: 'Raipur – Swami Vivekananda Airport (RPR)', search: 'raipur swami vivekananda airport rpr varp chhattisgarh india', iata_code: 'RPR' },
    { label: 'Surat Airport (STV)', search: 'surat airport stv vasu gujarat india', iata_code: 'STV' },
    { label: 'Jammu Airport (IXJ)', search: 'jammu airport ixj viju jammu and kashmir india', iata_code: 'IXJ' },
    { label: 'Imphal – Bir Tikendrajit International Airport (IMF)', search: 'imphal bir tikendrajit international airport imf veim manipur india', iata_code: 'IMF' },
    { label: 'Hubballi Airport (HBX)', search: 'hubballi hubli airport hbx vahb karnataka india', iata_code: 'HBX' },
    { label: 'Aurangabad Airport (IXU)', search: 'aurangabad airport ixu vaau maharashtra india', iata_code: 'IXU' },
    { label: 'Tirupati Airport (TIR)', search: 'tirupati airport tir votp andhra pradesh india', iata_code: 'TIR' },
    { label: 'Vijayawada Airport (VGA)', search: 'vijayawada airport vga vobz andhra pradesh india', iata_code: 'VGA' },
    { label: 'Tiruchirapalli International Airport (TRZ)', search: 'tiruchirapalli trichy international airport trz votr tamil nadu india', iata_code: 'TRZ' },
    { label: 'Udaipur – Maharana Pratap Airport (UDR)', search: 'udaipur maharana pratap airport udr vaud rajasthan india', iata_code: 'UDR' },
    { label: 'Jodhpur Airport (JDH)', search: 'jodhpur airport jdh vijo rajasthan india', iata_code: 'JDH' },
    { label: 'Patna – Jay Prakash Narayan Airport (PAT)', search: 'patna jay prakash narayan airport pat vept bihar india', iata_code: 'PAT' },
    { label: 'Gaya Airport (GAY)', search: 'gaya airport gay vegy bihar india', iata_code: 'GAY' },
    { label: 'Bhopal – Raja Bhoj Airport (BHO)', search: 'bhopal raja bhoj airport bho vabp madhya pradesh india', iata_code: 'BHO' },
    { label: 'Jabalpur – Dumna Airport (JLR)', search: 'jabalpur dumna airport jlr vajb madhya pradesh india', iata_code: 'JLR' },
    { label: 'Gwalior Airport (GWL)', search: 'gwalior airport gwl vigr madhya pradesh india', iata_code: 'GWL' },
    { label: 'Rajkot International Airport (RAJ)', search: 'rajkot international airport hirasar raj vark gujarat india', iata_code: 'RAJ' },
    { label: 'Bhavnagar Airport (BHU)', search: 'bhavnagar airport bhu vabv gujarat india', iata_code: 'BHU' },
    { label: 'Porbandar Airport (PBD)', search: 'porbandar airport pbd vapr gujarat india', iata_code: 'PBD' },
    { label: 'Nashik International Airport (ISK)', search: 'nashik international airport isk vaoz maharashtra india', iata_code: 'ISK' },
    { label: 'Ludhiana – Sahnewal Airport (LUH)', search: 'ludhiana sahnewal airport luh vild punjab india', iata_code: 'LUH' },
    { label: 'Prayagraj – Bamrauli Airport (IXD)', search: 'prayagraj allahabad bamrauli airport ixd vial uttar pradesh india', iata_code: 'IXD' },
    { label: 'Shimla Airport (SLV)', search: 'shimla airport slv vism himachal pradesh india', iata_code: 'SLV' },
    { label: 'Pantnagar Airport (PGH)', search: 'pantnagar airport pgh vipt uttarakhand india', iata_code: 'PGH' },
    { label: 'Dibrugarh Airport (DIB)', search: 'dibrugarh mohanbari airport dib vemn assam india', iata_code: 'DIB' },
    { label: 'Silchar Airport (IXS)', search: 'silchar airport ixs veku assam india', iata_code: 'IXS' },
    { label: 'Aizawl – Lengpui Airport (AJL)', search: 'aizawl lengpui airport ajl veaz mizoram india', iata_code: 'AJL' },
    { label: 'Shillong Airport (SHL)', search: 'shillong umroi airport shl veum meghalaya india', iata_code: 'SHL' },
    { label: 'Gangtok – Pakyong Airport (PYG)', search: 'gangtok pakyong airport pyg vepy sikkim india', iata_code: 'PYG' },
    { label: 'Bikaner – Nal Airport (BKB)', search: 'bikaner nal airport bkb vibk rajasthan india', iata_code: 'BKB' },
    { label: 'Mangaluru – Mangalore International Airport (IXE)', search: 'mangaluru mangalore international airport ixe voml karnataka india', iata_code: 'IXE' },
    { label: 'Thiruvananthapuram International Airport (TRV)', search: 'thiruvananthapuram trivandrum international airport trv votv kerala india', iata_code: 'TRV' },
    { label: 'Dubai International Airport (DXB)', search: 'dubai international airport dxb omdb uae dubai middle east', iata_code: 'DXB' },
    { label: 'Abu Dhabi – Zayed International Airport (AUH)', search: 'abu dhabi zayed international airport auh omaa uae middle east', iata_code: 'AUH' },
    { label: 'Sharjah International Airport (SHJ)', search: 'sharjah international airport shj omsj uae middle east', iata_code: 'SHJ' },
    { label: 'Ras Al Khaimah International Airport (RKT)', search: 'ras al khaimah international airport rkt omrk uae middle east', iata_code: 'RKT' },
    { label: 'Fujairah International Airport (FJR)', search: 'fujairah international airport fjr omfj uae middle east', iata_code: 'FJR' },
    { label: 'Al Ain International Airport (AAN)', search: 'al ain international airport aan omal uae middle east', iata_code: 'AAN' },
    { label: 'Dubai – Al Maktoum International Airport (DWC)', search: 'dubai al maktoum international airport dwc omdw jebel ali uae middle east', iata_code: 'DWC' },
    { label: 'Doha – Hamad International Airport (DOH)', search: 'doha hamad international airport doh othh qatar middle east', iata_code: 'DOH' },
    { label: 'Kuwait International Airport (KWI)', search: 'kuwait city international airport kwi okbk kuwait middle east', iata_code: 'KWI' },
    { label: 'Bahrain International Airport (BAH)', search: 'manama bahrain international airport bah obbi middle east', iata_code: 'BAH' },
    { label: 'Muscat International Airport (MCT)', search: 'muscat international airport mct ooms oman middle east', iata_code: 'MCT' },
    { label: 'Salalah International Airport (SLL)', search: 'salalah international airport sll oosa oman middle east', iata_code: 'SLL' },
    { label: 'Riyadh – King Khalid International Airport (RUH)', search: 'riyadh king khalid international airport ruh oerk saudi arabia middle east', iata_code: 'RUH' },
    { label: 'Jeddah – King Abdulaziz International Airport (JED)', search: 'jeddah king abdulaziz international airport jed oejn saudi arabia mecca middle east', iata_code: 'JED' },
    { label: 'Dammam – King Fahd International Airport (DMM)', search: 'dammam king fahd international airport dmm oedf saudi arabia middle east', iata_code: 'DMM' },
    { label: 'Medina – Prince Mohammad bin Abdulaziz International Airport (MED)', search: 'medina prince mohammad bin abdulaziz international airport med oema saudi arabia middle east', iata_code: 'MED' },
    { label: 'Abha International Airport (AHB)', search: 'abha international airport ahb oeab saudi arabia middle east', iata_code: 'AHB' },
    { label: 'Taif International Airport (TIF)', search: 'taif international airport tif oetf saudi arabia middle east', iata_code: 'TIF' },
    { label: 'Amman – Queen Alia International Airport (AMM)', search: 'amman queen alia international airport amm ojai jordan middle east', iata_code: 'AMM' },
    { label: 'Amman Civil Airport – Marka (ADJ)', search: 'amman civil airport marka adj ojam jordan middle east', iata_code: 'ADJ' },
    { label: 'Aqaba – King Hussein International Airport (AQJ)', search: 'aqaba king hussein international airport aqj ojaq jordan middle east', iata_code: 'AQJ' },
    { label: 'Beirut–Rafic Hariri International Airport (BEY)', search: 'beirut rafic hariri international airport bey olba lebanon middle east', iata_code: 'BEY' },
    { label: 'Baghdad International Airport (BGW)', search: 'baghdad international airport bgw orbi iraq middle east', iata_code: 'BGW' },
    { label: 'Basra International Airport (BSR)', search: 'basra international airport bsr ormm iraq middle east', iata_code: 'BSR' },
    { label: 'Erbil International Airport (EBL)', search: 'erbil international airport ebl orer iraq kurdistan middle east', iata_code: 'EBL' },
    { label: 'Najaf International Airport (NJF)', search: 'najaf international airport njf orni iraq middle east', iata_code: 'NJF' },
    { label: 'Tel Aviv – Ben Gurion International Airport (TLV)', search: 'tel aviv ben gurion international airport tlv llbg israel middle east', iata_code: 'TLV' },
    { label: 'Damascus International Airport (DAM)', search: 'damascus international airport dam osdi syria middle east', iata_code: 'DAM' },
    { label: "Sana'a International Airport (SAH)", search: 'sanaa international airport sah oysn yemen middle east', iata_code: 'SAH' },
    { label: 'Kathmandu – Tribhuvan International Airport (KTM)', search: 'kathmandu tribhuvan international airport ktm vnkt nepal south asia', iata_code: 'KTM' },
    { label: 'Siddharthanagar – Gautam Buddha International Airport (BWA)', search: 'siddharthanagar bhairahawa gautam buddha international airport bwa vnbw nepal south asia', iata_code: 'BWA' },
    { label: 'Biratnagar Airport (BIR)', search: 'biratnagar airport bir vnvt nepal south asia', iata_code: 'BIR' },
    { label: 'Lukla – Tenzing-Hillary Airport (LUA)', search: 'lukla tenzing hillary airport lua vnlk everest nepal south asia', iata_code: 'LUA' },
    { label: 'Pokhara Airport (PKR)', search: 'pokhara airport pkr vnpk nepal south asia', iata_code: 'PKR' },
    { label: 'Colombo – Bandaranaike International Airport (CMB)', search: 'colombo bandaranaike international airport cmb vcbi sri lanka south asia', iata_code: 'CMB' },
    { label: 'Hambantota – Mattala Rajapaksa International Airport (HRI)', search: 'hambantota mattala rajapaksa international airport hri vcri sri lanka south asia', iata_code: 'HRI' },
    { label: 'Jaffna International Airport (JAF)', search: 'jaffna international airport jaf vccj sri lanka south asia', iata_code: 'JAF' },
    { label: 'Karachi – Jinnah International Airport (KHI)', search: 'karachi jinnah international airport khi opkc pakistan south asia', iata_code: 'KHI' },
    { label: 'Lahore – Allama Iqbal International Airport (LHE)', search: 'lahore allama iqbal international airport lhe opla pakistan south asia', iata_code: 'LHE' },
    { label: 'Islamabad International Airport (ISB)', search: 'islamabad international airport isb opis pakistan south asia', iata_code: 'ISB' },
    { label: 'Peshawar – Bacha Khan International Airport (PEW)', search: 'peshawar bacha khan international airport pew opps pakistan south asia', iata_code: 'PEW' },
    { label: 'Quetta International Airport (UET)', search: 'quetta international airport uet opqt pakistan south asia', iata_code: 'UET' },
    { label: 'Multan International Airport (MUX)', search: 'multan international airport mux opmt pakistan south asia', iata_code: 'MUX' },
    { label: 'Sialkot International Airport (SKT)', search: 'sialkot international airport skt opst pakistan south asia', iata_code: 'SKT' },
    { label: 'Faisalabad International Airport (LYP)', search: 'faisalabad international airport lyp opfa pakistan south asia', iata_code: 'LYP' },
    { label: 'Gwadar International Airport (GWD)', search: 'gwadar international airport gwd opgd pakistan south asia', iata_code: 'GWD' },
    { label: 'Skardu International Airport (KDU)', search: 'skardu international airport kdu opsd pakistan south asia', iata_code: 'KDU' },
    { label: 'Rahim Yar Khan – Shaikh Zaid Airport (RYK)', search: 'rahim yar khan shaikh zaid airport ryk oprk pakistan south asia', iata_code: 'RYK' },
    { label: 'Dhaka – Hazrat Shahjalal International Airport (DAC)', search: 'dhaka hazrat shahjalal international airport dac vghs bangladesh south asia', iata_code: 'DAC' },
    { label: 'Chittagong – Shah Amanat International Airport (CGP)', search: 'chittagong shah amanat international airport cgp vgeg bangladesh south asia', iata_code: 'CGP' },
    { label: 'Sylhet – Osmani International Airport (ZYL)', search: 'sylhet osmani international airport zyl vgsy bangladesh south asia', iata_code: 'ZYL' },
    { label: "Cox's Bazar Airport (CXB)", search: 'coxs bazar airport cxb vgcb bangladesh south asia', iata_code: 'CXB' },
    { label: 'Saidpur Airport (SPD)', search: 'saidpur airport spd vgsd bangladesh south asia', iata_code: 'SPD' },
    { label: 'Jessore Airport (JSR)', search: 'jessore airport jsr vgjr bangladesh south asia', iata_code: 'JSR' },
    { label: 'Rajshahi – Shah Makhdum Airport (RJH)', search: 'rajshahi shah makhdum airport rjh vgrj bangladesh south asia', iata_code: 'RJH' },
    { label: 'Barisal Airport (BZL)', search: 'barisal airport bzl vgbr bangladesh south asia', iata_code: 'BZL' },
    { label: 'Malé – Velana International Airport (MLE)', search: 'male velana international airport mle vrmm maldives south asia', iata_code: 'MLE' },
    { label: 'Addu City – Gan International Airport (GAN)', search: 'addu city gan international airport gan vrmg maldives south asia', iata_code: 'GAN' },
    { label: 'Hanimaadhoo International Airport (HAQ)', search: 'hanimaadhoo international airport haq vrmh maldives south asia', iata_code: 'HAQ' }
  ];

  function escapeHtml(value) {
    const element = document.createElement('div');
    element.textContent = String(value || '');
    return element.innerHTML;
  }

  function createSubmissionId() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') {
      return window.crypto.randomUUID();
    }

    return `dmc-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 12)}`;
  }

  function toIsoDate(date) {
    if (!(date instanceof Date) || Number.isNaN(date.getTime())) {
      return '';
    }

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
  }

  function dateFromIso(value) {
    if (!value || !/^\d{4}-\d{2}-\d{2}$/.test(value)) {
      return null;
    }

    const parts = value.split('-').map(Number);
    return new Date(parts[0], parts[1] - 1, parts[2]);
  }

  function showMessage(messageBox, text, type) {
    if (!messageBox) return;
    messageBox.textContent = text;
    messageBox.className = `dmc-flight-widget__message is-visible dmc-flight-widget__message--${type}`;
  }

  function clearMessage(messageBox) {
    if (!messageBox) return;
    messageBox.textContent = '';
    messageBox.className = 'dmc-flight-widget__message';
  }

  function setBodyLock(shouldLock) {
    document.body.classList.toggle(BODY_LOCK_CLASS, shouldLock);
    document.body.style.overflow = shouldLock ? 'hidden' : '';
  }

  function getAirportFallbackMatches(term) {
    const query = String(term || '').trim().toLowerCase();

    if (query.length < 2) {
      return [];
    }

    return LOCAL_AIRPORTS
      .filter(function (airport) {
        return (
          airport.label.toLowerCase().includes(query) ||
          airport.search.includes(query) ||
          airport.iata_code.toLowerCase().includes(query)
        );
      })
      .slice(0, 8)
      .map(function (airport) {
        return {
          label: airport.label,
          type: 'airport',
          iata_code: airport.iata_code
        };
      });
  }

  /* ---------------------------------------------------------------------
   * Media stage: hover-preview (desktop), tap-preview (mobile),
   * and click-to-expand modal with sound.
   * ------------------------------------------------------------------- */

  function extractYoutubeId(rawUrl) {
    if (!rawUrl) return '';

    const patterns = [
      /youtu\.be\/([\w-]{6,})/,
      /youtube\.com\/watch\?v=([\w-]{6,})/,
      /youtube\.com\/embed\/([\w-]{6,})/,
      /youtube\.com\/shorts\/([\w-]{6,})/
    ];

    for (let i = 0; i < patterns.length; i += 1) {
      const match = rawUrl.match(patterns[i]);
      if (match) return match[1];
    }

    return '';
  }

  function getYoutubeEmbedSrc(rawUrl, options) {
    const opts = options || {};
    const id = extractYoutubeId(rawUrl);

    if (!id) return '';

    const params = [
      `autoplay=${opts.autoplay ? 1 : 0}`,
      `mute=${opts.mute ? 1 : 0}`,
      `controls=${opts.controls === false ? 0 : 1}`,
      `loop=${opts.loop ? 1 : 0}`,
      'playsinline=1',
      'rel=0',
      'modestbranding=1'
    ];

    if (opts.loop) params.push(`playlist=${id}`);

    return `https://www.youtube.com/embed/${id}?${params.join('&')}`;
  }

  function stopMediaLayer(layer) {
    if (!layer) return;

    const video = layer.querySelector('video');
    const iframe = layer.querySelector('iframe[data-dmc-youtube]');

    if (video) {
      video.pause();
    }

    if (iframe) {
      iframe.src = '';
    }

    layer.classList.remove('is-playing');
  }

  function playMediaLayer(layer, options) {
    if (!layer) return;

    const opts = options || {};
    const video = layer.querySelector('video');
    const iframe = layer.querySelector('iframe[data-dmc-youtube]');

    layer.classList.add('is-playing');

    if (video) {
      video.muted = opts.mute !== false;
      video.loop = true;
      video.playsInline = true;

      const playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function () {});
      }
    }

    if (iframe) {
      const rawUrl = iframe.getAttribute('data-dmc-media-url');
      const src = getYoutubeEmbedSrc(rawUrl, {
        autoplay: true,
        mute: opts.mute !== false,
        loop: true,
        controls: false
      });

      if (src) iframe.src = src;
    }
  }

  function initialiseMedia(widget) {
    const stage = widget.querySelector('[data-dmc-media-stage]');
    const expandButton = widget.querySelector('[data-dmc-media-expand]');
    const dialog = widget.querySelector('[data-dmc-media-dialog]');
    const dialogContent = widget.querySelector('[data-dmc-media-dialog-content]');
    const dialogClose = widget.querySelector('[data-dmc-media-dialog-close]');
    const previewMedia = widget.getAttribute('data-dmc-preview-media') || 'none';

    if (!stage) return;

    const activeLayer = previewMedia !== 'none'
      ? widget.querySelector(`[data-dmc-media-source="${previewMedia}"]`)
      : null;

    const isCoarsePointer = Boolean(
      window.matchMedia && window.matchMedia('(pointer: coarse)').matches
    );

    let previewOpen = false;

    function openPreview() {
      if (!activeLayer || previewOpen) return;
      previewOpen = true;
      playMediaLayer(activeLayer, { mute: true });
    }

    function closePreview() {
      if (!activeLayer || !previewOpen) return;
      previewOpen = false;
      stopMediaLayer(activeLayer);
    }

    if (activeLayer) {
      if (isCoarsePointer) {
        stage.addEventListener('click', function (event) {
          if (expandButton && (event.target === expandButton || expandButton.contains(event.target))) {
            return;
          }

          if (previewOpen) {
            closePreview();
          } else {
            openPreview();
          }
        });
      } else {
        stage.addEventListener('mouseenter', openPreview);
        stage.addEventListener('mouseleave', closePreview);
        stage.addEventListener('focusin', openPreview);
        stage.addEventListener('focusout', closePreview);
      }
    }

    function buildExpandedContent() {
      if (!dialogContent || !activeLayer) return false;

      dialogContent.innerHTML = '';

      const sourceType = activeLayer.getAttribute('data-dmc-media-source');

      if (sourceType === 'video_file') {
        const originalVideo = activeLayer.querySelector('video');
        if (!originalVideo) return false;

        const clone = originalVideo.cloneNode(true);
        clone.muted = false;
        clone.controls = true;
        clone.autoplay = true;
        clone.loop = true;
        clone.removeAttribute('preload');
        dialogContent.appendChild(clone);

        const playPromise = clone.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(function () {});
        }
      } else {
        const iframeSource = activeLayer.querySelector('iframe[data-dmc-youtube]');
        if (!iframeSource) return false;

        const rawUrl = iframeSource.getAttribute('data-dmc-media-url');
        const src = getYoutubeEmbedSrc(rawUrl, {
          autoplay: true,
          mute: false,
          loop: true,
          controls: true
        });

        if (!src) return false;

        const embedIframe = document.createElement('iframe');
        embedIframe.setAttribute('title', iframeSource.getAttribute('title') || 'Travel video');
        embedIframe.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture');
        embedIframe.setAttribute('allowfullscreen', '');
        embedIframe.src = src;
        dialogContent.appendChild(embedIframe);
      }

      return true;
    }

    function closeDialog() {
      if (!dialog) return;
      if (dialogContent) dialogContent.innerHTML = '';

      if (typeof dialog.close === 'function' && dialog.open) {
        dialog.close();
      } else {
        dialog.removeAttribute('open');
      }
    }

    if (expandButton && dialog && dialogContent) {
      expandButton.addEventListener('click', function (event) {
        event.stopPropagation();
        closePreview();

        const built = buildExpandedContent();
        if (!built) return;

        if (typeof dialog.showModal === 'function') {
          dialog.showModal();
        } else {
          dialog.setAttribute('open', '');
        }
      });

      if (dialogClose) {
        dialogClose.addEventListener('click', closeDialog);
      }

      dialog.addEventListener('click', function (event) {
        if (event.target === dialog) closeDialog();
      });

      dialog.addEventListener('cancel', function (event) {
        event.preventDefault();
        closeDialog();
      });

      dialog.addEventListener('close', function () {
        if (dialogContent) dialogContent.innerHTML = '';
      });
    }
  }

  /* ---------------------------------------------------------------------
   * Date pickers: two fully independent single-date Flatpickr instances.
   * ------------------------------------------------------------------- */

  function initialiseDatePicker(widget) {
    const startVisible = widget.querySelector('[data-dmc-date-start-input]');
    const endVisible = widget.querySelector('[data-dmc-date-end-input]');
    const startInput = widget.querySelector('[data-dmc-travel-start]');
    const endInput = widget.querySelector('[data-dmc-travel-end]');
    const tripTypeInput = widget.querySelector('[data-dmc-trip-type]');
    const returnField = widget.querySelector('[data-dmc-return-field]');

    if (!startVisible || !endVisible || !startInput || !endInput || !tripTypeInput) {
      return null;
    }

    let startPicker = null;
    let endPicker = null;
    let usingFallback = false;

    function getTripType() {
      return tripTypeInput.value === 'round_trip'
        ? 'round_trip'
        : 'one_way';
    }

    function buildStartPicker() {
      if (startPicker) {
        startPicker.destroy();
        startPicker = null;
      }

      if (typeof window.flatpickr !== 'function') {
        usingFallback = true;
        startVisible.removeAttribute('readonly');
        startVisible.placeholder = 'YYYY-MM-DD';
        return;
      }

      const preserved = dateFromIso(startInput.value);

      startPicker = window.flatpickr(startVisible, {
        mode: 'single',
        minDate: 'today',
        disableMobile: true,
        allowInput: false,
        dateFormat: 'Y-m-d',
        altInput: true,
        altFormat: 'd M Y',
        onChange: function (selectedDates) {
          const date = selectedDates[0] || null;
          startInput.value = date ? toIsoDate(date) : '';
          startVisible.classList.remove('is-invalid-date');

          if (endPicker && date) {
            endPicker.set('minDate', date);

            const currentEnd = dateFromIso(endInput.value);
            if (currentEnd && currentEnd < date) {
              endPicker.clear();
              endInput.value = '';
            }
          }

          widget.dispatchEvent(new Event('dmc:fieldchange'));
        }
      });

      if (preserved) {
        startPicker.setDate(preserved, false);
      }
    }

    function buildEndPicker() {
      if (endPicker) {
        endPicker.destroy();
        endPicker = null;
      }

      if (typeof window.flatpickr !== 'function') {
        return;
      }

      const minDate = dateFromIso(startInput.value) || 'today';

      endPicker = window.flatpickr(endVisible, {
        mode: 'single',
        minDate: minDate,
        disableMobile: true,
        allowInput: false,
        dateFormat: 'Y-m-d',
        altInput: true,
        altFormat: 'd M Y',
        onChange: function (selectedDates) {
          const date = selectedDates[0] || null;
          endInput.value = date ? toIsoDate(date) : '';
          endVisible.classList.remove('is-invalid-date');
          widget.dispatchEvent(new Event('dmc:fieldchange'));
        }
      });

      const preserved = dateFromIso(endInput.value);
      if (preserved) {
        endPicker.setDate(preserved, false);
      }
    }

    function setReturnEnabled(enabled) {
      if (enabled) {
        endVisible.removeAttribute('disabled');
        endVisible.placeholder = 'Select return date';
        if (returnField) returnField.classList.remove('is-disabled-field');
        buildEndPicker();
      } else {
        if (endPicker) {
          endPicker.destroy();
          endPicker = null;
        }
        endVisible.setAttribute('disabled', 'disabled');
        endVisible.value = '';
        endVisible.placeholder = 'Select "Round trip" first';
        endVisible.classList.remove('is-invalid-date');
        endInput.value = '';
        if (returnField) returnField.classList.add('is-disabled-field');
      }
    }

    function setTripType(nextTripType) {
      setReturnEnabled(nextTripType === 'round_trip');
      widget.dispatchEvent(new Event('dmc:fieldchange'));
    }

    buildStartPicker();
    setReturnEnabled(getTripType() === 'round_trip');

    if (typeof window.flatpickr !== 'function') {
      let attempts = 0;
      const upgradeTimer = window.setInterval(function () {
        attempts += 1;
        if (typeof window.flatpickr === 'function') {
          window.clearInterval(upgradeTimer);
          usingFallback = false;
          buildStartPicker();
          setReturnEnabled(getTripType() === 'round_trip');
        } else if (attempts >= 20) {
          window.clearInterval(upgradeTimer);
        }
      }, 250);
    }

    return {
      setTripType,
      getTripType,
      hasValidSelection: function () {
        if (getTripType() !== 'round_trip') {
          return Boolean(startInput.value);
        }

        return Boolean(startInput.value) && Boolean(endInput.value);
      },
      flagIncomplete: function () {
        endVisible.classList.add('is-invalid-date');
      },
      clearFlag: function () {
        endVisible.classList.remove('is-invalid-date');
      },
      clear: function () {
        startInput.value = '';
        endInput.value = '';
        if (startPicker) startPicker.clear();
        if (endPicker) endPicker.clear();
      }
    };
  }

  function initialiseTripType(widget, dateController) {
    const tripTypeInput = widget.querySelector('[data-dmc-trip-type]');
    const buttons = widget.querySelectorAll('[data-dmc-trip-segment]');

    if (!tripTypeInput || !buttons.length) return;

    function applyTripType(value) {
      const tripType = value === 'round_trip'
        ? 'round_trip'
        : 'one_way';

      tripTypeInput.value = tripType;

      buttons.forEach(function (button) {
        const active = button.getAttribute('data-dmc-trip-segment') === tripType;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      if (dateController) {
        dateController.setTripType(tripType);
        dateController.clearFlag();
      }

      widget.dispatchEvent(new Event('dmc:fieldchange'));
    }

    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        applyTripType(button.getAttribute('data-dmc-trip-segment'));
      });
    });

    applyTripType(tripTypeInput.value || 'one_way');
  }

  function initialiseAutocomplete(widget) {
    widget
      .querySelectorAll('[data-dmc-location-input]')
      .forEach(function (input) {
        const field = input.closest('.dmc-flight-widget__field');
        const dropdown = field
          ? field.querySelector('[data-dmc-autocomplete]')
          : null;
        const role = input.getAttribute('data-dmc-airport-input');
        const iataInput = widget.querySelector(
          role === 'from'
            ? '[data-dmc-from-iata]'
            : '[data-dmc-to-iata]'
        );

        if (!dropdown || !role || !iataInput) return;

        let matches = [];
        let highlightedIndex = -1;
        let sequence = 0;
        let timer = null;

        function closeDropdown() {
          dropdown.innerHTML = '';
          dropdown.classList.remove('is-open');
          matches = [];
          highlightedIndex = -1;
        }

        function invalidateSelection() {
          iataInput.value = '';
          input.setCustomValidity('Please select an airport from the suggestions.');
          widget.dispatchEvent(new Event('dmc:fieldchange'));
        }

        function choose(option) {
          if (!option || option.type !== 'airport' || !option.iata_code) return;

          input.value = option.label;
          iataInput.value = String(option.iata_code).trim().toUpperCase();
          input.setCustomValidity('');
          closeDropdown();
          widget.dispatchEvent(new Event('dmc:fieldchange'));
        }

        function render() {
          if (!matches.length) {
            closeDropdown();
            return;
          }

          dropdown.innerHTML = matches
            .map(function (option, index) {
              return `
                <button type="button" class="dmc-flight-widget__autocomplete-option" data-dmc-autocomplete-option="${index}" role="option">
                  <span class="dmc-flight-widget__autocomplete-main">${escapeHtml(option.label)}</span>
                  <span class="dmc-flight-widget__autocomplete-meta">Airport code: ${escapeHtml(option.iata_code)}</span>
                </button>
              `;
            })
            .join('');

          dropdown.classList.add('is-open');

          dropdown
            .querySelectorAll('[data-dmc-autocomplete-option]')
            .forEach(function (button) {
              button.addEventListener('mousedown', function (event) {
                event.preventDefault();
                choose(matches[Number(button.getAttribute('data-dmc-autocomplete-option'))]);
              });
            });
        }

        async function search() {
          const term = input.value.trim();

          if (term.length < 2) {
            closeDropdown();
            return;
          }

          const requestId = ++sequence;

          try {
            const response = await fetch(
              `${LOCATION_API_URL}?q=${encodeURIComponent(term)}&types=airport&limit=8`,
              { headers: { Accept: 'application/json' } }
            );

            if (!response.ok) throw new Error('Airport lookup failed');

            const payload = await response.json();

            if (requestId !== sequence) return;

            matches = Array.isArray(payload.results)
              ? payload.results.filter(function (option) {
                  return option && option.type === 'airport' && option.iata_code;
                })
              : [];

            if (!matches.length) {
              matches = getAirportFallbackMatches(term);
            }
          } catch (error) {
            if (requestId !== sequence) return;
            matches = getAirportFallbackMatches(term);
          }

          render();
        }

        input.addEventListener('input', function () {
          invalidateSelection();
          window.clearTimeout(timer);
          timer = window.setTimeout(search, 220);
        });

        input.addEventListener('keydown', function (event) {
          if (!dropdown.classList.contains('is-open')) return;

          if (event.key === 'ArrowDown') {
            event.preventDefault();
            highlightedIndex = Math.min(highlightedIndex + 1, matches.length - 1);
          } else if (event.key === 'ArrowUp') {
            event.preventDefault();
            highlightedIndex = Math.max(highlightedIndex - 1, 0);
          } else if (event.key === 'Enter' && highlightedIndex >= 0) {
            event.preventDefault();
            choose(matches[highlightedIndex]);
          } else if (event.key === 'Escape') {
            closeDropdown();
            return;
          }

          dropdown
            .querySelectorAll('[data-dmc-autocomplete-option]')
            .forEach(function (button, index) {
              button.classList.toggle('is-highlighted', index === highlightedIndex);
            });
        });

        input.addEventListener('blur', function () {
          window.setTimeout(closeDropdown, 160);
        });

        invalidateSelection();
      });
  }

  function initialiseSteppers(widget) {
    widget.querySelectorAll('[data-dmc-stepper]').forEach(function (stepper) {
      const input = stepper.querySelector('[data-dmc-stepper-input]');
      const decrease = stepper.querySelector('[data-dmc-stepper-decrease]');
      const increase = stepper.querySelector('[data-dmc-stepper-increase]');

      if (!input || !decrease || !increase) return;

      const minimum = Number(input.min || 0);
      const maximum = Number(input.max || 999);

      function clamp(value) {
        const parsed = Number.parseInt(value, 10);
        return Math.min(maximum, Math.max(minimum, Number.isInteger(parsed) ? parsed : minimum));
      }

      function setValue(value) {
        input.value = String(clamp(value));
        widget.dispatchEvent(new Event('dmc:fieldchange'));
      }

      decrease.addEventListener('click', function () {
        setValue(Number(input.value) - 1);
      });

      increase.addEventListener('click', function () {
        setValue(Number(input.value) + 1);
      });

      input.addEventListener('change', function () {
        input.value = String(clamp(input.value));
        widget.dispatchEvent(new Event('dmc:fieldchange'));
      });
    });
  }

  /* ---------------------------------------------------------------------
   * Submission.
   * ------------------------------------------------------------------- */

  function initialiseSubmission(widget, dateController) {
    const form = widget.querySelector('[data-dmc-form]');
    const message = widget.querySelector('[data-dmc-message]');
    const submit = widget.querySelector('[data-dmc-submit]');
    const submissionId = widget.querySelector('[data-dmc-submission-id]');
    const startInput = widget.querySelector('[data-dmc-travel-start]');
    const endInput = widget.querySelector('[data-dmc-travel-end]');
    const tripTypeInput = widget.querySelector('[data-dmc-trip-type]');
    const fromIata = widget.querySelector('[data-dmc-from-iata]');
    const toIata = widget.querySelector('[data-dmc-to-iata]');

    if (!form || !submit || !submissionId) return;

    let submittedSuccessfully = false;

    function getTripType() {
      return tripTypeInput && tripTypeInput.value === 'round_trip'
        ? 'round_trip'
        : 'one_way';
    }

    function isRoundTripIncomplete() {
      if (getTripType() !== 'round_trip') return false;

      if (dateController) {
        return !dateController.hasValidSelection();
      }

      return !endInput || !endInput.value;
    }

    function validateForm(showErrors) {
      const missing = [];
      const tripType = getTripType();

      if (!fromIata || !fromIata.value) missing.push('Select a departure airport from the suggestions.');
      if (!toIata || !toIata.value) missing.push('Select an arrival airport from the suggestions.');

      if (
        fromIata &&
        toIata &&
        fromIata.value &&
        toIata.value &&
        fromIata.value.trim().toUpperCase() === toIata.value.trim().toUpperCase()
      ) {
        missing.push('Departure and arrival airports must be different.');
      }

      const dateSelectionValid = dateController
        ? dateController.hasValidSelection()
        : !isRoundTripIncomplete() && Boolean(startInput && startInput.value);

      if (!dateSelectionValid) {
        if (!startInput || !startInput.value) {
          missing.push('Select a departure date.');
        } else if (tripType === 'round_trip') {
          missing.push('Select a return date to complete your round trip.');
        } else {
          missing.push('Select a departure date.');
        }
      }

      const adults = form.elements.adults;
      const name = form.elements.name;
      const phone = form.elements.phone;
      const email = form.elements.email;
      const contactTime = form.elements.preferred_contact_time;
      const consent = form.elements.contact_consent;

      if (!adults || Number(adults.value) < 1) missing.push('Choose at least one adult.');
      if (!name || !name.value.trim()) missing.push('Enter your full name.');
      if (!phone || !phone.value.trim()) missing.push('Enter your phone or WhatsApp number.');
      if (!email || !email.validity.valid) missing.push('Enter a valid email address.');

      if (contactTime) {
        const contactTimeMissing = !contactTime.value;
        contactTime.classList.toggle('is-invalid', contactTimeMissing && contactTime.dataset.dmcTouched === 'true');
        if (contactTimeMissing) missing.push('Choose the best time to contact you.');
      }

      if (!consent || !consent.checked) missing.push('Please agree to be contacted about this flight enquiry.');

      const valid = missing.length === 0;

      if (showErrors && !valid) {
        showMessage(message, missing[0], 'error');
      }

      return { valid, message: missing[0] || '' };
    }

    function updateSubmitState() {
      if (form.dataset.dmcSubmitting === 'true') return;
      if (submittedSuccessfully) return;

      const validation = validateForm(false);
      submit.disabled = !validation.valid;
      submit.classList.remove('is-submitted');
      submit.textContent = validation.valid
        ? 'Request flight assistance'
        : 'Complete required fields';
    }

    function resetForChangedData() {
      if (form.dataset.dmcSubmitting === 'true') return;

      if (submittedSuccessfully) {
        submittedSuccessfully = false;
        submissionId.value = createSubmissionId();
        submit.classList.remove('is-submitted');
      }

      clearMessage(message);
      updateSubmitState();
    }

    const contactTimeSelect = form.elements.preferred_contact_time;
    if (contactTimeSelect) {
      contactTimeSelect.addEventListener('blur', function () {
        contactTimeSelect.dataset.dmcTouched = 'true';
        updateSubmitState();
      });
    }

    submissionId.value = createSubmissionId();

    form.addEventListener('input', resetForChangedData);
    form.addEventListener('change', resetForChangedData);
    widget.addEventListener('dmc:fieldchange', resetForChangedData);

    form.addEventListener('submit', async function (event) {
      event.preventDefault();

      if (form.dataset.dmcSubmitting === 'true' || submittedSuccessfully) return;

      if (isRoundTripIncomplete()) {
        showMessage(message, 'Please select a return date, or switch to One way.', 'error');
        if (dateController) {
          dateController.flagIncomplete();
        }
        updateSubmitState();
        return;
      }

      const validation = validateForm(true);

      if (!validation.valid) {
        updateSubmitState();
        return;
      }

      form.dataset.dmcSubmitting = 'true';
      submit.disabled = true;
      submit.classList.remove('is-submitted');
      submit.textContent = 'Submitting…';
      clearMessage(message);

      const payload = Object.fromEntries(new FormData(form).entries());

      try {
        const controller = new AbortController();
        const timeoutId = window.setTimeout(function () {
          controller.abort();
        }, 25000);

        let response;

        try {
          response = await fetch(WORKER_URL, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            body: JSON.stringify(payload),
            signal: controller.signal
          });
        } finally {
          window.clearTimeout(timeoutId);
        }

        const responseText = await response.text();
        let result = {};

        try {
          result = responseText ? JSON.parse(responseText) : {};
        } catch (error) {
          throw new Error(`The server returned an invalid response (${response.status}).`);
        }

        if (!response.ok || !result.success) {
          throw new Error(result.message || `The server rejected the request (${response.status}).`);
        }

        form.dataset.dmcSubmitting = 'false';
        submittedSuccessfully = true;
        submit.disabled = true;
        submit.classList.add('is-submitted');
        submit.textContent = 'Submitted ✓';

        showMessage(
          message,
          result.duplicate
            ? 'This flight enquiry was already received. Our travel desk will contact you shortly.'
            : 'Thank you! Your flight enquiry has been received. Our travel desk will contact you shortly.',
          'success'
        );
      } catch (error) {
        const messageText =
          error && error.name === 'AbortError'
            ? 'The request timed out. Please check your connection and try again. Your enquiry may already have been received.'
            : error && error.message
              ? error.message
              : 'We could not submit your flight enquiry right now. Please try again.';

        showMessage(message, messageText, 'error');

        form.dataset.dmcSubmitting = 'false';
        updateSubmitState();
      }
    });

    updateSubmitState();
  }

  /* ---------------------------------------------------------------------
   * Open/close, with persisted "minimised" state for floating mode.
   * ------------------------------------------------------------------- */

  function initialiseOpenClose(widget) {
    const trigger = widget.querySelector('[data-dmc-trigger]');
    const panel = widget.querySelector('[data-dmc-panel]');
    const closeButton = widget.querySelector('[data-dmc-close]');
    const reopenButton = widget.querySelector('[data-dmc-reopen]');
    const backdrop = widget.querySelector('[data-dmc-backdrop]');
    const modal = widget.getAttribute('data-dmc-open-behaviour') === 'modal';
    const floating = widget.getAttribute('data-dmc-widget-mode') === 'floating';
    const storageKey = 'dmc-flight-widget:minimised:' + (widget.id || 'default');

    if (!trigger || !panel) return;

    function readStoredMinimised() {
      if (!floating) return false;
      try {
        return window.localStorage.getItem(storageKey) === 'true';
      } catch (error) {
        return false;
      }
    }

    function writeStoredMinimised(value) {
      if (!floating) return;
      try {
        if (value) {
          window.localStorage.setItem(storageKey, 'true');
        } else {
          window.localStorage.removeItem(storageKey);
        }
      } catch (error) {}
    }

    function openPanel() {
      panel.hidden = false;
      widget.classList.add('is-open');
      widget.classList.remove('is-minimised');
      trigger.setAttribute('aria-expanded', 'true');
      if (modal) {
        if (backdrop) backdrop.classList.add('is-visible');
        setBodyLock(true);
      }
      writeStoredMinimised(false);
    }

    function closePanel(minimise) {
      panel.hidden = true;
      widget.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');
      if (modal) {
        if (backdrop) backdrop.classList.remove('is-visible');
        setBodyLock(false);
      }
      if (minimise && floating) {
        widget.classList.add('is-minimised');
        writeStoredMinimised(true);
      }
    }

    trigger.addEventListener('click', openPanel);
    if (closeButton) closeButton.addEventListener('click', function () { closePanel(true); });
    if (reopenButton) reopenButton.addEventListener('click', openPanel);
    if (backdrop) backdrop.addEventListener('click', function () { closePanel(true); });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && widget.classList.contains('is-open')) {
        closePanel(true);
      }
    });

    if (widget.getAttribute('data-dmc-initial-state') === 'open') {
      openPanel();
    }

    if (readStoredMinimised()) {
      widget.classList.add('is-minimised');
    }
  }

  function safeRun(label, fn) {
    try {
      fn();
    } catch (error) {
      if (window.console && typeof window.console.warn === 'function') {
        window.console.warn(`[dmc-flight-widget] ${label} failed to initialise:`, error);
      }
    }
  }

  function initialiseWidget(widget) {
    if (!widget || widget.dataset.dmcFlightWidgetInitialised === 'true') return;
    widget.dataset.dmcFlightWidgetInitialised = 'true';

    safeRun('open/close', function () {
      initialiseOpenClose(widget);
    });

    let dateController = null;
    safeRun('date picker', function () {
      dateController = initialiseDatePicker(widget);
    });

    safeRun('trip type', function () {
      initialiseTripType(widget, dateController);
    });

    safeRun('autocomplete', function () {
      initialiseAutocomplete(widget);
    });

    safeRun('steppers', function () {
      initialiseSteppers(widget);
    });

    safeRun('media', function () {
      initialiseMedia(widget);
    });

    safeRun('submission', function () {
      initialiseSubmission(widget, dateController);
    });
  }

  function initialiseAllWidgets(root) {
    (root || document)
      .querySelectorAll('[data-dmc-flight-widget]')
      .forEach(initialiseWidget);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initialiseAllWidgets(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initialiseAllWidgets(event.target);
  });
})();